type QuoteOrder = {
  order_type?: string | null
  status?: string | null
} | null

// Catering quotes and held OLO quotes are fixed offers: the customer can accept
// and pay, but cannot change the cart, location, time or contact details.
export const isFixedQuote = (order?: QuoteOrder): boolean =>
  order?.order_type === 'CATERING' ||
  (order?.order_type === 'OLO' && order?.status === 'HELD')
